module.exports = __webpack_public_path__ + "img/demo.92f09ea1.png";